import { render, staticRenderFns } from "./ghMenu.vue?vue&type=template&id=044ae0ec&scoped=true&"
import script from "./ghMenu.vue?vue&type=script&lang=js&"
export * from "./ghMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044ae0ec",
  null
  
)

export default component.exports